import { datadogRum } from '@datadog/browser-rum'
import { actionCreatorAsync } from 'client/actions/index'

import { Config } from '../config'

export const initializeDataDog = () => {
  return async (dispatch, getState) => {
    await dispatch(
      actionCreatorAsync('INITIALIZE_DATADOG', async () => {
        const webpackDefineVars = Config.getVarsFromWebpackDefinePlugin()
        const userId = getState().token?.userId
        const userEmail = getState().token?.email
        const companyId = getState().token?.['custom:companyId']

        if (webpackDefineVars.workspace === 'prod') {
          datadogRum.init({
            applicationId: Config.getDatadogApplicationId(),
            clientToken: Config.getDatadogClientToken(),
            // `site` refers to the Datadog site parameter of your organization
            // see https://docs.datadoghq.com/getting_started/site/
            site: 'datadoghq.eu',
            service: 'zervant-ui',
            env: 'prod',
            version: webpackDefineVars.version, // "test" or commit sha for production
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            /**
             * To control datadog costs, you can adjust sample rates here
             *
             * More info:
             * https://docs.datadoghq.com/real_user_monitoring/guide/best-practices-for-rum-sampling/
             * https://docs.datadoghq.com/logs/log_collection/javascript/#initialization-parameters
             */
            sessionSampleRate: 100,
            sessionReplaySampleRate: 0.1,
            telemetrySampleRate: 5,
          })

          datadogRum.setUser({
            id: userId,
            name: companyId,
            email: userEmail,
          })
        }
      }),
    )
  }
}
